"use client";

import { formatName } from "../../lib/util";
import { useHistoryManager } from "../history/useHistoryManager";

export const AccountInfo = ({
  loggedInUser,
  setIsChangingPassword,
  handleLogout,
}) => {
  // const { navigateTo } = useHistoryManager();
  return (
    <>
      <div className="nav-header">
        <h3>Account Information</h3>
        <p className="logout-link" onClick={handleLogout}>
          Logout
        </p>
      </div>
      <div className="nav-body">
        <div className="info">
          <p className="info-label">First Name</p>
          <p className="info-value">
            {formatName(loggedInUser?.user.firstName)}
          </p>
        </div>
        <div className="info">
          <p className="info-label">Last Name</p>
          <p className="info-value">
            {formatName(loggedInUser?.user.lastName)}
          </p>
        </div>
        <div className="info">
          <p className="info-label">Email</p>
          <p className="info-value">{loggedInUser?.user.email}</p>
        </div>
        <div className="info">
          {loggedInUser?.user.phone ? (
            <>
              <p className="info-label">Phone Number</p>
              <p className="info-value">
                {loggedInUser?.user.intCode}
                {loggedInUser?.user.phone}
              </p>
            </>
          ) : (
            <>
              <p className="info-label">Phone Number</p>
              <p className="info-value">N/A</p>
            </>
          )}
        </div>
        <p
          className="logout-link"
          onClick={() => {
            setIsChangingPassword(true);
            // navigateTo(`profile/account/password`, {
            //   replace: true,
            //   onNavigate: (navigate) => {
            //     if (navigate) {
            //       setIsChangingPassword(true);
            //     }
            //   },
            // });
          }}
        >
          Change Password?
        </p>
      </div>
    </>
  );
};
